export default __webpack_public_path__ + "static/media/avatar_bg_konan.22147fad.png";